export default function getHoldPosition(holdData) {
    if (holdData.holdListPosition > 0) {
        return holdData.holdListPosition;
    }

    const onSaleDate = new Date(holdData.estimatedReleaseDate).getTime();
    const ownedCopies = holdData.ownedCopies | 0;
    const isPreSale = holdData.isPreReleaseTitle;
    const estimatedWaitDays = holdData.estimatedWaitDays | 0;
    const daysDiff = (onSaleDate - Date.now()) / (1000 * 60 * 60 * 24);

    let holdPosition;
    if (isPreSale) {
        holdPosition = ((estimatedWaitDays - daysDiff) / 14) * ownedCopies;
    } else {
        holdPosition = (estimatedWaitDays / 14) * ownedCopies;
    }
    return Math.round(Math.abs(holdPosition));
}
